var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history d-flex-c-ast-jfs-gap15"},[_c('h2',{staticClass:"p-30"},[_vm._v("تاریخچه")]),_c('trades'),_c('transactions'),_c('login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }